import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import EditFilter from 'components/settings/DynamicApplicationGeneration/Filters/edit';
import ViewFilter from 'components/settings/DynamicApplicationGeneration/Filters/view';
import CreateFilter from 'components/settings/DynamicApplicationGeneration/Filters/create';
import Filters from 'components/settings/DynamicApplicationGeneration/Filters';

const FiltersContainer = () => {
    const match = useRouteMatch();
    const basePath = match.path;
    return (
        <Switch>
            <Route path={`${basePath}/:id/view`} exact component={ViewFilter} />
            <Route path={`${basePath}/:id/edit`} exact component={EditFilter} />
            <Route path={`${basePath}/create`} exact component={CreateFilter} />
            <Route component={Filters} />
        </Switch>
    );
};

export default FiltersContainer;
